import { render } from "./LinkJiraIssue.vue?vue&type=template&id=587c0046&scoped=true"
import script from "./LinkJiraIssue.vue?vue&type=script&lang=js"
export * from "./LinkJiraIssue.vue?vue&type=script&lang=js"

import "./LinkJiraIssue.vue?vue&type=style&index=0&id=587c0046&lang=scss&scoped=true"
import "./LinkJiraIssue.vue?vue&type=style&index=1&id=587c0046&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587c0046"]])

export default __exports__